



















import Vue from "vue";
import { MODULE_COLORS } from "@/utility/Constants";

// Vue Components
import AppPage from "@/components/AppPage.vue";
import CaosConfigurationTemplateMainTable from "@/views/App/SecurityAndConfiguration/CaosConfigurationTemplate/CaosConfigurationTemplateMainTable.vue";

//Model
import { CreateGetConfigurationTemplateReqData, GetConfigurationTemplateCommand } from "@/model/communication/caosConfiguration/GetConfigurationTemplateCommand";
import { GetConfigurationTemplateResData } from "@/model/communication/caosConfiguration/GetConfigurationTemplateResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        AppPage,
        CaosConfigurationTemplateMainTable,
    },

    data() {
        return {
            MODULE_COLORS,
            configurationTemplate: [],
            configurationTemplateLoading: false,
            reqData: null,
            currentPaginationOptions: null,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.configurationTemplateLoading = true;
                let response: GetConfigurationTemplateResData = await new GetConfigurationTemplateCommand(CreateGetConfigurationTemplateReqData(request)).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.configurationTemplate = response.caosConfigurationTemplates;
                }
            } catch (e) {
                console.log("Something went wrong sending GetConfigurationTemplate request ", e);
            }
            this.configurationTemplateLoading = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },

        onReload() {
            console.debug("Send request to reload data");
            this.sendRequest(this.reqData);
        },

        onOptionsChanged(newOptions) {
            let needToSendRequest: boolean = false;

            if (
                this.currentPaginationOptions == null ||
                newOptions.page != this.currentPaginationOptions.page ||
                newOptions.itemsPerPage != this.currentPaginationOptions.itemsPerPage ||
                newOptions.sortBy.length != this.currentPaginationOptions.sortBy.length ||
                (newOptions.sortBy &&
                    newOptions.sortBy.length == 1 &&
                    this.currentPaginationOptions.sortBy &&
                    this.currentPaginationOptions.sortBy.length == 1 &&
                    newOptions.sortBy[0] != this.currentPaginationOptions.sortBy[0]) ||
                (newOptions.sortDesc &&
                    newOptions.sortDesc.length == 1 &&
                    this.currentPaginationOptions.sortDesc &&
                    this.currentPaginationOptions.sortDesc.length == 1 &&
                    newOptions.sortDesc[0] != this.currentPaginationOptions.sortDesc[0])
            )
                needToSendRequest = true;

            this.currentPaginationOptions = newOptions;

            if (needToSendRequest) {
                let newReqData = Object.assign({}, this.reqData);
                newReqData.offset = (this.currentPaginationOptions.page - 1) * this.currentPaginationOptions.itemsPerPage;
                newReqData.queryLimit = this.currentPaginationOptions.itemsPerPage;
                newReqData.orderBy = this.currentPaginationOptions.sortBy;
                newReqData.orderByDescending = this.currentPaginationOptions.sortDesc;
                this.sendRequest(newReqData);
            }
        },

        onFiltersChanged(filters) {
            let newReqData = Object.assign({}, this.reqData);
            newReqData.offset = 0;

            filters.forEach((filter) => {
                newReqData[filter.filterKey] = filter.currentSelections;
            });
            this.$refs.mainTable.backToTheFirst();
            this.sendRequest(newReqData);
        },
    },
});
